// eslint-disable-next-line no-shadow
export enum ToastType {
	UPLOAD_IMAGE_ERROR = 'upload_image_error',

	DEFAULT_SOMETHING_WENT_WRONG_TRY_AGAIN = 'default_something_went_wrong_try_again',
	REFRESH_ON_API_FAILURE = 'refresh_on_api_failure',

	GENERATE_API_ERROR = 'generate_api_error',

	NO_MODEL_SELECTED = 'no_model_selected',

	GENERATE_STUDIO_IMAGE_API_SUCCESS = 'generate_studio_image_api_success',
	GENERATE_STUDIO_IMAGE_LOW_BALANCE_ERROR = 'generate_studio_image_low_balance_error',
	GENERATE_STUDIO_IMAGE_LOW_ALLOWANCE_ERROR = 'generate_studio_image_low_allowance_error',

	LINK_COPIED = 'link_copied',
	VIDEO_LINK_COPIED = 'video_link_copied',
	PROMPT_LINK_COPIED = 'prompt_link_copied',

	VALUE_COPIED = 'value_copied',

	PAGE_LINK_COPIED = 'page_link_copied',
	PROMPT_UNPUBLISHED = 'prompt_unpublished',
	GET_CREDIT_OPTIONS_FAILED = 'get_credit_options_failed',
	UPDATE_PROFILE_SUCCESS = 'update_profile_success',

	FILE_SIZE_TOO_LARGE = 'file_size_too_large',
	INCOMPATIBLE_FILE_TYPE = 'incompatible_file_type',
	IMAGE_DIMENSIONS_TOO_LARGE = 'image_dimensions_too_large',
	FAILED_TO_GET_ENHANCE_COSTS = 'failed_to_get_enhance_costs',
	FAILED_TO_GET_ENHANCE_CAP = 'failed_to_get_enhance_cap',
	FAILED_TO_GET_COST = 'failed_to_get_cost',

	VIDEO_FRAMES_LIMIT_REACHED = 'video_frames_limit_reached',
	INCOMPATIBLE_VIDEO_FILE_TYPE = 'incompatible_video_file_type',
	VIDEO_FILE_SIZE_TOO_LARGE = 'video_file_size_too_large',
	FAILED_TO_GET_VIDEO_GENERATION_COSTS = 'failed_to_get_video_generation_costs',

	AUDIO_FILE_SIZE_TOO_LARGE = 'audio_file_size_too_large',
	AUDIO_DURATION_TOO_LONG = 'audio_duration_too_long',
	INCOMPATIBLE_AUDIO_FILE_TYPE = 'incompatible_audio_file_type',

	EMPTY_USERNAME = 'empty_username',
	CUSTOM = 'custom',
	PLEASE_VERIFY_EMAIL = 'please_verify_email',
	RESET_PASSWORD_LINK_SENT = 'reset_password_link_sent',
	FAILED_TO_SAVE_NAME = 'failed_to_save_name',
	FAILED_TO_SEND_VERIFICATION_EMAIL = 'failed_to_send_verification_email',
	EMAIL_ALREADY_IN_USE = 'email_already_in_use',
	DEFAULT_EMAIL_NOT_VERIFIED = 'default_email_not_verified',
	OUT_OF_CREDITS = 'out_of_credits',
	NSFW_CONTENT = 'nsfw_content',
	CANVAS_ID_NOT_FOUND = 'canvas_id_not_found',
	CANVAS_LIMIT_REACHED = 'canvas_limit_reached',

	DELETE_ASSET_ERROR = 'delete_asset_error',
	ASSET_FETCH_ERROR = 'asset_fetch_error',
	UPLOAD_ASSET_ERROR = 'upload_asset_error',
	CANNOT_SELECT_ASSET_ERROR = 'cannot_select_asset_error',
	NSFW_ASSET_IS_NOT_ALLOWED = 'nsfw_asset_not_allowed',

	CH01 = 'ch_01',

	DOWNLOAD_ERROR = 'download_error',
	DOWNLOAD_SUCCESS = 'download_success',
	DOWNLOAD_PENDING = 'download_pending',

	LIP_SYNC_VOICES_LIST_FETCH_ERROR = 'lip_sync_voices_list_fetch_error',
	LIP_SYNC_VIDEO_GENERATION_ERROR = 'lip_sync_generation_error',

	TOO_MANY_LIPSYNC_GENERATIONS = 'too_many_lipsync_generations',

	FAILED_TO_APPLY_COUPON = 'failed_to_apply_coupon',
	UPGRADE_TO_USE_MAGIC_MODE_AND_PRO_MODE = 'upgrade_to_use_magic_and_pro_mode',
	GEN_FAILED_DUE_TO_CONTENT_MODERATION = 'gen_failed_due_to_content_moderation',
	NSFW_CHARACTER_PROMPT_DESCRIPTION = 'nsfw_character_prompt_description',
	VIDEO_GENERATION_FAILED = 'Video generation failed. Your credits have been refunded. Please try again.',
}
